/* Sendepause – ersetzt Judge.me-Standard-Avatare durch runde Initialen (aus dem Namen).
   Läuft nach dem Laden + beobachtet das Widget (Sortieren/Umblättern). */
(function () {
  function initials(name) {
    name = (name || '').replace(/\s+/g, ' ').trim();
    if (!name) return '★';
    var p = name.split(' ');
    var s = (p[0][0] || '') + (p.length > 1 ? (p[p.length - 1][0] || '') : '');
    return s.toUpperCase();
  }
  function relTime(str) {
    str = (str || '').trim();
    var d = null;
    var us = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/); // MM/DD/YYYY
    if (us) d = new Date(+us[3], +us[1] - 1, +us[2]);
    else { var t = Date.parse(str); if (!isNaN(t)) d = new Date(t); }
    if (!d || isNaN(d.getTime())) return null;
    var days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days < 0) days = 0;
    if (days === 0) return 'heute';
    if (days === 1) return 'gestern';
    if (days < 7) return 'vor ' + days + ' Tagen';
    if (days < 31) { var w = Math.floor(days / 7); return 'vor ' + w + (w === 1 ? ' Woche' : ' Wochen'); }
    if (days < 365) { var mo = Math.floor(days / 30); return 'vor ' + mo + (mo === 1 ? ' Monat' : ' Monaten'); }
    var y = Math.floor(days / 365); return 'vor ' + y + (y === 1 ? ' Jahr' : ' Jahren');
  }
  function process() {
    var revs = document.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < revs.length; i++) {
      var rev = revs[i];
      var icon = rev.querySelector('.jdgm-rev__icon');
      var author = rev.querySelector('.jdgm-rev__author');
      if (icon && author && icon.getAttribute('data-sp') !== '1') {
        icon.setAttribute('data-sp', '1');
        var nm = author.textContent || '';
        icon.innerHTML = '<span class="sp-ava">' + initials(nm) + '</span>';
        var h = 0; for (var k = 0; k < nm.length; k++) { h = (h * 31 + nm.charCodeAt(k)) % 99991; }
        icon.classList.add('sp-av-' + ((h % 6) + 1));
      }
      if (author && author.getAttribute('data-spv') !== '1') {
        author.setAttribute('data-spv', '1');
        var seal = document.createElement('span');
        seal.className = 'sp-verified';
        seal.setAttribute('title', 'Verifizierter Kauf');
        seal.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M12 2.2l2.3 1.7 2.9-.3.9 2.7 2.5 1.5-.9 2.8.9 2.8-2.5 1.5-.9 2.7-2.9-.3L12 21.8l-2.3-1.7-2.9.3-.9-2.7L3.4 16l.9-2.8L3.4 10l2.5-1.5.9-2.7 2.9.3z" fill="#51abff"/><path d="M10.6 14.2l-1.9-1.9-1.1 1.1 3 3 5-5-1.1-1.1z" fill="#fff"/></svg>';
        if (author.nextSibling) author.parentNode.insertBefore(seal, author.nextSibling);
        else author.parentNode.appendChild(seal);
      }
      var ts = rev.querySelector('.jdgm-rev__timestamp');
      if (ts && ts.getAttribute('data-sp') !== '1') {
        var rel = relTime(ts.textContent);
        if (rel) { ts.setAttribute('data-sp', '1'); ts.textContent = rel; }
      }
    }
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(process, 150); }
  function init() {
    process();
    var widg = document.querySelector('.jdgm-rev-widg') || document.body;
    try {
      new MutationObserver(schedule).observe(widg, { childList: true, subtree: true });
    } catch (e) {}
    // Fallback-Polling für den asynchronen App-Load
    var n = 0, iv = setInterval(function () { process(); if (++n > 20) clearInterval(iv); }, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 600); });
  else setTimeout(init, 600);
})();
